import { render, staticRenderFns } from "./BackgroundHostingList.vue?vue&type=template&id=35a01075&"
import script from "./BackgroundHostingList.vue?vue&type=script&lang=js&"
export * from "./BackgroundHostingList.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundHostingList.vue?vue&type=style&index=0&id=35a01075&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports